export const CONTRACT_STATUS = {
  active: {
    label: 'Active',
    className: 'bg-emerald-500/15 text-emerald-700 ring-emerald-500/30',
  },
  under_renewal: {
    label: 'Under Renewal',
    className: 'bg-amber-500/15 text-amber-700 ring-amber-500/30',
  },
  suspended: {
    label: 'Suspended',
    className: 'bg-red-500/15 text-red-700 ring-red-500/30',
  },
};

export const TRANSPORTER_PARTNERS = [
  {
    id: 'TRP-001',
    name: 'Al-Futtaim Logistics',
    tradeLicense: 'CN-DXB-884210',
    fleetSize: 15,
    driversCount: 22,
    contractStatus: 'active',
    insuranceValidUntil: '2026-11-30',
    primaryContact: '+971 4 123 4500',
    emirate: 'Dubai',
    documentsCount: 8,
  },
  {
    id: 'TRP-002',
    name: 'Emirates Transport',
    tradeLicense: 'CN-AUH-556789',
    fleetSize: 28,
    driversCount: 41,
    contractStatus: 'active',
    insuranceValidUntil: '2027-02-15',
    primaryContact: '+971 2 678 9100',
    emirate: 'Abu Dhabi',
    documentsCount: 12,
  },
  {
    id: 'TRP-003',
    name: 'Gulf Haulage & Tankers LLC',
    tradeLicense: 'CN-SHJ-339012',
    fleetSize: 9,
    driversCount: 14,
    contractStatus: 'under_renewal',
    insuranceValidUntil: '2026-07-20',
    primaryContact: '+971 6 543 2100',
    emirate: 'Sharjah',
    documentsCount: 6,
  },
  {
    id: 'TRP-004',
    name: 'Ruwais Heavy Transport Co.',
    tradeLicense: 'CN-AUH-112890',
    fleetSize: 12,
    driversCount: 18,
    contractStatus: 'active',
    insuranceValidUntil: '2026-09-01',
    primaryContact: '+971 2 801 3344',
    emirate: 'Abu Dhabi',
    documentsCount: 9,
  },
  {
    id: 'TRP-005',
    name: 'Jebel Ali Fleet Services',
    tradeLicense: 'CN-DXB-667234',
    fleetSize: 6,
    driversCount: 9,
    contractStatus: 'under_renewal',
    insuranceValidUntil: '2026-08-10',
    primaryContact: '+971 4 881 2200',
    emirate: 'Dubai',
    documentsCount: 5,
  },
];

export const RATE_MODELS = [
  {
    id: 'per_trip',
    label: 'Per Trip Model',
    icon: 'route',
    description: 'Fixed rate per completed route leg',
    color: 'cyan',
    rates: [
      { id: 'PT-01', label: 'Dubai → Abu Dhabi', value: 500, unit: 'AED / trip', client: 'ADNOC' },
      { id: 'PT-02', label: 'Jebel Ali → Sharjah Industrial', value: 380, unit: 'AED / trip', client: 'Emirates Gas' },
      { id: 'PT-03', label: 'Ruwais → Fujairah Port', value: 720, unit: 'AED / trip', client: 'ADNOC' },
      { id: 'PT-04', label: 'Habshan → Mussafah', value: 450, unit: 'AED / trip', client: 'Borouge' },
    ],
  },
  {
    id: 'per_km',
    label: 'Per KM Model',
    icon: 'gauge',
    description: 'Distance-based billing with GPS odometer validation',
    color: 'violet',
    rates: [
      { id: 'PK-01', label: 'Standard Tanker (Fuel)', value: 3.5, unit: 'AED / km', client: 'All clients' },
      { id: 'PK-02', label: 'Hazmat Chemical Tanker', value: 4.8, unit: 'AED / km', client: 'Emirates Gas' },
      { id: 'PK-03', label: 'LPG Trailer (Escort req.)', value: 5.2, unit: 'AED / km', client: 'ENOC' },
      { id: 'PK-04', label: 'Empty Return Leg', value: 1.5, unit: 'AED / km', client: 'All clients' },
    ],
  },
  {
    id: 'per_mt',
    label: 'Per Metric Ton (MT)',
    icon: 'weight',
    description: 'Weight-based — Chemical & Bitumen tankers',
    color: 'amber',
    rates: [
      { id: 'PM-01', label: 'Bitumen Tanker', value: 12, unit: 'AED / MT', client: 'ADNOC' },
      { id: 'PM-02', label: 'Chemical Bulk (Class 3)', value: 15.5, unit: 'AED / MT', client: 'Emirates Gas' },
      { id: 'PM-03', label: 'Bulk Powder (Cement/Fly Ash)', value: 8, unit: 'AED / MT', client: 'GPIC' },
      { id: 'PM-04', label: 'Sulphur Granular', value: 11, unit: 'AED / MT', client: 'ADNOC' },
    ],
  },
  {
    id: 'per_kl',
    label: 'Per Kiloliter (KL)',
    icon: 'droplets',
    description: 'Volume-based — Fuel & Gas Oil tankers',
    color: 'emerald',
    rates: [
      { id: 'PL-01', label: 'Gas Oil / Diesel', value: 8, unit: 'AED / KL', client: 'ADNOC' },
      { id: 'PL-02', label: 'Motor Gasoline (Mogas)', value: 9.5, unit: 'AED / KL', client: 'ENOC' },
      { id: 'PL-03', label: 'Jet Fuel (Aviation)', value: 12, unit: 'AED / KL', client: 'ADNOC' },
      { id: 'PL-04', label: 'LPG (Bulk Liquid)', value: 14, unit: 'AED / KL', client: 'Emirates Gas' },
    ],
  },
  {
    id: 'fixed_monthly',
    label: 'Fixed Monthly / Dedicated Fleet',
    icon: 'calendar',
    description: 'Long-term dedicated fleet lease contracts',
    color: 'blue',
    rates: [
      {
        id: 'FM-01',
        label: 'ADNOC Dedicated Fleet — 5 Tankers',
        value: 45000,
        unit: 'AED / month',
        client: 'ADNOC',
      },
      {
        id: 'FM-02',
        label: 'Emirates Gas LPG Fleet — 3 Trailers',
        value: 32000,
        unit: 'AED / month',
        client: 'Emirates Gas',
      },
      {
        id: 'FM-03',
        label: 'ENOC Port Shuttle — 2 Tankers',
        value: 28000,
        unit: 'AED / month',
        client: 'ENOC',
      },
      {
        id: 'FM-04',
        label: 'Jebel Ali Terminal Standby — 4 Units',
        value: 52000,
        unit: 'AED / month',
        client: 'DP World',
      },
    ],
  },
];

export const MODEL_COLORS = {
  cyan: {
    bg: 'bg-logi-accent/10',
    ring: 'ring-logi-accent/30',
    text: 'text-logi-accent',
    border: 'border-logi-accent/30',
  },
  violet: {
    bg: 'bg-logi-accent/10',
    ring: 'ring-violet-500/25',
    text: 'text-logi-accent',
    border: 'border-violet-500/30',
  },
  amber: {
    bg: 'bg-amber-50',
    ring: 'ring-amber-500/25',
    text: 'text-amber-700',
    border: 'border-amber-200',
  },
  emerald: {
    bg: 'bg-emerald-50',
    ring: 'ring-emerald-500/25',
    text: 'text-emerald-700',
    border: 'border-emerald-200',
  },
  blue: {
    bg: 'bg-logi-accent/100/10',
    ring: 'ring-blue-500/25',
    text: 'text-blue-700',
    border: 'border-blue-500/30',
  },
};
